import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { DashboardSkeleton } from '@/components/ui/skeleton';

/**
 * Dashboard Route (/dashboard)
 * 
 * Implements Requirements 6.1, 6.2, 6.3, 11.2, 11.3:
 * - TanStack Router for type-safe routing
 * - Nested routes with layout composition
 * - Automatic code splitting per route
 * - Route-based code splitting with lazy()
 * - Suspense boundaries with skeleton loaders
 * 
 * Protected route that displays the main dashboard.
 * Inherits authentication guard from _authenticated layout.
 * Uses lazy loading for better initial load performance.
 */

// Lazy load the Dashboard component for code splitting
const Dashboard = lazy(() => import('@/pages/Dashboard'));

export const Route = createFileRoute('/_authenticated/dashboard')({
  component: () => (
    <Suspense fallback={<DashboardSkeleton />}>
      <Dashboard />
    </Suspense>
  ),
});
